<template>
  <form class="mt-2" id="form-modal">
    <!-- description input -->
    <div class="form-group">
      <label class="label-form">Password</label>
      <p class="alert alert-danger alert-dismissible" v-if="old_pass">
        <a href="#" class="close" data-dismiss="alert" aria-label="close" @click="clear">×</a>
        The password must be atleast 8 characters.
      </p>
       <input v-bind:type="[showPassword ? 'text' : 'password']" class="form-control password" name="password" v-model="password"
        placeholder="Enter New Password" type="text" id="password" required />
      <p v-if="password.length >= 1 && password.length < 8">
        <span class="text-danger">Password must be atleast 8 characters</span>
      </p>
    </div>
    <!-- confirm password-->
    <div class="form-group">
      <label class="label-form">Confirm Password</label>
        <input v-bind:type="[showPassword ? 'text' : 'password']" class="form-control password" name="confirm_password" v-model="confirm_password" 
        placeholder="Confirm New Password" type="text" id="confirm_password" required />
      <p v-if="confirm_password.length >= 1 && confirm_password.length < 8">
        <span class="text-danger">Password must be identical</span>
      </p>
      <p class="alert alert-danger alert-dismissible" v-if="confirm_pass">
        <a href="#" class="close" data-dismiss="alert" aria-label="close" @click="quit">×</a>
        The password confirmation does not match.
      </p>
    </div>
    <div class="control">
      <input type="checkbox" @click="showPassword = !showPassword;"> Show Password
    </div>
    <!-- buttons -->
    <div class="form-footer text-right">
      <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="clear">
        Close
      </button>
      <button type="button" class="btn btn-default ml-1" @click="save">
        Save
      </button>
    </div>
  </form>
</template>

<script>
  import axios from "axios";
  
  export default {
    props: ["action", "formData", "pageNumber", "status"],
    data: function () {
      return {
        showPassword: false,
        password: "",
        confirm_password: "",
        old_pass: false,
        confirm_pass: false,
      };
    },
    computed: function () {
      this.old_pass = false;
      this.confirm_pass = false;
    },
    created: function () {
      this.old_pass = false;
      this.confirm_pass = false;
      this.password = "";
      this.confirm_password = "";
    },
    methods: {
      save() {
        let demo_id = this.formData.user;
        let password = this.password;
        let confirm_pass = this.confirm_password;
        if (this.validatePassword(password)) {
          if (password === confirm_pass) {
             const permission = {
      headers: {
        'X-Permission': 'admin_users_resetpassword' // Setting the custom header
      }
    };
            //let page_no = this.formData.pageNumber;
            axios
              .post("/admin/users/reset-user-password", {
                newPassword: password,
                id: demo_id,
              },permission)
              .then(() => {
                this.$toast.success("Password Set Successfully");
                window.$("#modal").modal("hide");
                this.clear();
                this.$store.dispatch("users/getadminusersBySearch", [
                  "",
                  this.formData.selectedType.id,
                ]);
              })
              .catch((error) => {
                this.$toast.error(error);
              });
          } else {
            this.confirm_pass = true;
          }
        } else {
          this.old_pass = true;
        }
      },
      validatePassword(p) {
        if (p.length < 8) {
          // errors.push("Your password must be at least 8 characters");
          return false;
        }

        return true;
      },
      clear() {
        this.old_pass = false;
        this.confirm_pass = false;
        this.password = "";
        this.confirm_password = "";
      },
      quit() {
        this.old_pass = false;
        this.confirm_pass = false;
      },
    },
  };
</script>